module.exports = __webpack_public_path__ + "static/media/zoom_mais.746fac09.svg";